import { render, staticRenderFns } from "./BuySongModal.vue?vue&type=template&id=ca94ddfe&scoped=true"
import script from "./BuySongModal.vue?vue&type=script&lang=ts"
export * from "./BuySongModal.vue?vue&type=script&lang=ts"
import style0 from "./BuySongModal.vue?vue&type=style&index=0&id=ca94ddfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca94ddfe",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QBtn});
